/** Cloudflare Turnstile: one fresh token per protected request (jobs, ad sessions). No site key = not used. */
import { loadScript } from "./scripts";

interface TurnstileApi {
  render(el: HTMLElement, opts: Record<string, unknown>): string;
  execute(widgetId: string): void;
  reset(widgetId: string): void;
}

declare global {
  interface Window {
    turnstile?: TurnstileApi;
  }
}

const SCRIPT = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export function turnstileTokenGetter(siteKey: string): () => Promise<string | null> {
  if (!siteKey) return async () => null;
  let widget: string | null = null;
  let waiting: ((token: string | null) => void) | null = null;
  return async () => {
    await loadScript(SCRIPT);
    const api = window.turnstile;
    if (!api) return null;
    return new Promise<string | null>((resolve) => {
      waiting = resolve;
      if (widget === null) {
        const host = document.createElement("div");
        host.className = "turnstile-host";
        document.body.appendChild(host);
        widget = api.render(host, {
          sitekey: siteKey,
          execution: "execute",
          appearance: "interaction-only",
          callback: (token: string) => waiting?.(token),
          "error-callback": () => waiting?.(null),
        });
      } else {
        api.reset(widget);
      }
      api.execute(widget);
    });
  };
}
